/* ==========================================================================
   assets/advcoti-buy-box.js
   The Jerry-C Pro three card buy box (snippets/advcoti-buy-box.liquid). NEW FILE.
   Built 2026-10-11 by lane advcoti-buybox-1011.

   What it does:
   1. The three cards are radios. The PVS-14 card carries a PRO / STANDARD
      housing toggle; pressing a pill also picks its card.
   2. 2026-10-14 (lane SHIP-PREDICT-1014, Bon: "u never ended up removing the
      1400 and 1600 fom pill selector from the third card and also i asked u to
      add the FOM slider section/container that should pop up when either the
      pvs-14 +coti and pvs-31 + coti is selected? oterwise how will ppl pick?"):
      the PVS-31 card has no pills any more. ONE tube grade slider sits under
      the three cards and shows only while a kit card is picked: every tier the
      night vision product has (PVS-14 1250 PRO only, 1400, 1600, 1800; PVS-31
      1400, 1600, 1800, 2000), sold out or not made tiers struck through and
      never reachable, the price step under each number. Stock and prices are
      read live from /products/<handle>.js on load.
   3. Every pick repaints the big price, the struck price, the button amount,
      the step value and the "What goes in the cart" list. A kit is the two
      prices less the kit saving (PVS-14 kits kitOff14, PVS-31 kits kitOff31).
      The saving is set in US dollars; outside US dollars Shopify converts it at
      the market rate, so the page converts it the same way and says "about".
   4. The green button posts every line of the pick to /cart/add.js in ONE
      request (night vision first, Jerry-C Pro second), then repaints the cart
      drawer with the drawer's own sections, like the PVS column. If the drawer
      cannot be driven the shopper lands on /cart.
   5. ARRIVAL. The store's own card above answers for the Jerry-C Pro in every
      country. On a kit this asks the same delivery-estimate function about the
      night vision half too. In the USA it says which part is slowest; outside
      it, one row per part, each in the server's own words.
   NO EM DASHES OR EN DASHES ANYWHERE IN THIS FILE.
   ========================================================================== */
(function () {
  'use strict';

  var MONTHS = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };

  function boot(root) {
    if (root.getAttribute('data-acb-bound') === '1') return;
    root.setAttribute('data-acb-bound', '1');

    var D;
    try { D = JSON.parse(root.querySelector('script[data-acb-data]').textContent); } catch (e) { return; }
    if (!D || !D.cards || !D.elf) return;

    var form = root.querySelector('[data-acb-form]');
    var addBtn = root.querySelector('[data-acb-add]');
    var addLabel = root.querySelector('[data-acb-addlabel]');
    var addPrice = root.querySelector('[data-acb-addprice]');
    var errEl = root.querySelector('[data-acb-err]');
    var priceEl = root.querySelector('[data-acb-price]');
    var wasEl = root.querySelector('[data-acb-was]');
    var vEl = root.querySelector('[data-acb-v]');
    var cartEl = root.querySelector('[data-acb-cart]');
    var estHead = root.querySelector('[data-acb-esthead]');
    var rowsEl = root.querySelector('[data-acb-rows]');
    var home = String(D.country || '').toUpperCase() === 'US';
    var usd = String(D.currency || 'USD').toUpperCase() === 'USD';

    /* ------------------------------------------------------------ money */
    var M = learnMoney(D.moneyProbe);
    function learnMoney(probe) {
      var s = String(probe == null ? '' : probe);
      var m = s.match(/[0-9][0-9.,   '`]*[0-9]|[0-9]/);
      if (!m) return null;
      var core = m[0];
      var out = { pre: s.slice(0, m.index), suf: s.slice(m.index + core.length), dec: 0, decSep: '.', grpSep: '' };
      var tail = core.match(/([.,])(\d{2})$/);
      var rest = core;
      if (tail) { out.dec = 2; out.decSep = tail[1]; rest = core.slice(0, core.length - 3); }
      var g = rest.match(/[.,   '`]/);
      if (g) out.grpSep = g[0];
      return out;
    }
    function money(cents) {
      var n = Number(cents);
      if (!isFinite(n)) return '';
      if (!M) return String(Math.round(n / 100));
      var neg = n < 0;
      n = Math.abs(n);
      var whole, frac = null;
      if (M.dec === 2) { whole = Math.floor(Math.round(n) / 100); frac = Math.round(n) % 100; } else { whole = Math.round(n / 100); }
      var w = String(whole);
      if (M.grpSep) w = w.replace(/\B(?=(\d{3})+(?!\d))/g, M.grpSep);
      return (neg ? '-' : '') + M.pre + w + (frac === null ? '' : M.decSep + (frac < 10 ? '0' : '') + frac) + M.suf;
    }
    /* a whole amount for badges ("Save $150"): no cents when they are zero */
    function moneyWhole(cents) {
      var s = money(cents);
      return M && M.dec === 2 ? s.replace(new RegExp('\\' + M.decSep + '00(?=\\D*$)'), '') : s;
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function setText(el, s) { if (el && el.textContent !== String(s)) el.textContent = String(s); }
    function setHtml(el, s) { if (el && el.innerHTML !== String(s)) el.innerHTML = String(s); }

    /* ------------------------------------------------------------ tiers */
    /* Every non HEAT tier of the two night vision products, from Liquid, then
       refreshed from the live product feed. */
    var T = { pvs14: (D.tiers && D.tiers.pvs14) || [], pvs31: (D.tiers && D.tiers.pvs31) || [] };
    /* an older snippet without the tier list: fall back to the card options it printed */
    ['pvs14', 'pvs31'].forEach(function (ck) {
      if (T[ck].length || !D.cards[ck] || !D.cards[ck].opts) return;
      var O = D.cards[ck].opts;
      for (var k in O) {
        if (!Object.prototype.hasOwnProperty.call(O, k)) continue;
        var m = String(O[k].sku || '').match(/-(PRO|STD)-(\d{4})$/i);
        if (m) T[ck].push({ h: m[1].toLowerCase(), fom: m[2], range: '', id: O[k].id, sku: O[k].sku, price: O[k].price, available: O[k].available === true });
      }
    });
    function num(f) { return parseInt(f, 10) || 0; }
    function fomsOf(cardKey) {
      var seen = {}, out = [];
      for (var i = 0; i < T[cardKey].length; i++) { var f = T[cardKey][i].fom; if (!seen[f]) { seen[f] = 1; out.push(f); } }
      out.sort(function (a, b) { return num(a) - num(b); });
      return out;
    }
    function tierOf(cardKey, h, fom) {
      var L = T[cardKey];
      for (var i = 0; i < L.length; i++) if (L[i].fom === fom && (cardKey !== 'pvs14' || L[i].h === h)) return L[i];
      return null;
    }
    function live(t) { return !!(t && t.available === true && t.id); }

    /* ------------------------------------------------------------ state */
    var S = {
      card: 'alone',
      h14: (D.cards.pvs14 && D.cards.pvs14.opt) || 'pro',
      f: { pvs14: '1400', pvs31: (D.cards.pvs31 && D.cards.pvs31.opt) || '1400' }
    };
    function housingOf(cardKey) { return cardKey === 'pvs14' ? S.h14 : 'pro'; }
    /* the chosen tier must be one that can be bought: snap to the nearest live one */
    function settle(cardKey) {
      if (cardKey === 'alone') return;
      var h = housingOf(cardKey);
      if (live(tierOf(cardKey, h, S.f[cardKey]))) return;
      var F = fomsOf(cardKey), at = F.indexOf(S.f[cardKey]); if (at < 0) at = 0;
      for (var s = 1; s < F.length; s++) {
        var c = [at + s, at - s];
        for (var j = 0; j < 2; j++) if (c[j] >= 0 && c[j] < F.length && live(tierOf(cardKey, h, F[c[j]]))) { S.f[cardKey] = F[c[j]]; return; }
      }
    }
    function companion(cardKey) {
      if (cardKey === 'alone') return null;
      var t = tierOf(cardKey, housingOf(cardKey), S.f[cardKey]);
      if (!t) return null;
      var base = cardKey === 'pvs14' ? 'PVS-14 ' + (t.h === 'std' ? 'STANDARD' : 'PRO') : 'PVS-31 PRO';
      return { id: t.id, sku: t.sku, price: t.price, compare: t.compare || 0, available: t.available === true,
        name: base + ' ' + (t.range || t.fom) + ' FOM', short: base + ' ' + t.fom };
    }
    function cardLive(cardKey) {
      if (cardKey === 'alone') return D.elf.available !== false;
      for (var i = 0; i < T[cardKey].length; i++) if (live(T[cardKey][i])) return true;
      return false;
    }
    /* THE KIT SAVING IN THE SHOPPER'S CURRENCY. The automatic discounts are set
       in US dollars; Shopify converts them at the market rate (measured 14 Oct:
       150 USD came off a Canadian cart as 213.07 CAD). */
    var RATE = 1;
    try { if (!usd && window.Shopify && Shopify.currency && Number(Shopify.currency.rate) > 0) RATE = Number(Shopify.currency.rate); } catch (e) { RATE = 1; }
    var APPROX = !usd;
    /* the kit saving as Bon set it, in US dollars, exactly (150 or 200) */
    function usd0(cardKey) {
      var v = cardKey === 'pvs14' ? D.kitOff14 : cardKey === 'pvs31' ? D.kitOff31 : 0;
      if (v == null && cardKey !== 'alone') v = D.kitOff;
      v = v > 0 ? v : 0;
      return (v % 100 === 0) ? String(v / 100) : (v / 100).toFixed(2);
    }
    function offFor(cardKey) {
      var v = cardKey === 'pvs14' ? D.kitOff14 : cardKey === 'pvs31' ? D.kitOff31 : 0;
      if (v == null && cardKey !== 'alone') v = D.kitOff;
      return v > 0 ? Math.round(v * RATE) : 0;
    }
    /* THE ONE STRUCK PRICE (Bon 15 Oct, 31B: one crossed out price per kit, the bigger one, everywhere). Each line at
       its compare at price, or its own price when it has none, added up. The dark kit cards further down the page add
       the same compare at prices (assets/advcoti-lander.js sum(kit, CMP)), so the two always agree. */
    function lineWas(price, compare) { return compare > price ? compare : price; }
    function wasOf(cardKey) {
      var o = companion(cardKey), w = lineWas(D.elf.price, D.elf.compare || 0);
      return o ? w + lineWas(o.price, o.compare || 0) : w;
    }
    window.noKitWas = function (lines) {
      var t = 0; for (var i = 0; i < lines.length; i++) t += lineWas(lines[i].price, lines[i].compare || 0); return t;
    };
    /* what the pick costs, and what it would cost bought apart */
    function priceOf(cardKey) {
      var o = companion(cardKey);
      if (!o) {
        if (cardKey !== 'alone') return { price: 0, was: 0, ok: false };
        return { price: D.elf.price, was: D.elf.compare > D.elf.price ? D.elf.compare : 0, ok: D.elf.available !== false };
      }
      var apart = o.price + D.elf.price;
      var off = offFor(cardKey);
      var was = wasOf(cardKey);
      return { price: apart - off, was: was > apart - off ? was : 0, ok: D.elf.available !== false && o.available === true };
    }
    function linesOf(cardKey) {
      var L = [];
      var o = companion(cardKey);
      if (o) L.push({ id: o.id, sku: o.sku, name: o.name, price: o.price });
      L.push({ id: D.elf.id, sku: D.elf.sku, name: D.shortName, price: D.elf.price, elf: true });
      return L;
    }

    /* ------------------------------------------------------------ the slider */
    var fomBox = root.querySelector('[data-acb-fom]');
    var fomV = root.querySelector('[data-acb-fomv]');
    var slider = root.querySelector('[data-acb-slider]');
    var range = root.querySelector('[data-acb-range]');
    var fill = root.querySelector('[data-acb-fill]');
    var knob = root.querySelector('[data-acb-knob]');
    var stopsEl = root.querySelector('[data-acb-stops]');
    var noteEl = root.querySelector('[data-acb-fomnote]');
    var sampleEl = root.querySelector('[data-acb-sample]');
    var sampleBtn = root.querySelector('[data-acb-zoomopen]');
    /* THE TIER PICTURE (Bon 14 Oct: "the tube grade fom selector is missing the images"). The same picture set the
       PVS-14 and PVS-31 pages use (no-buy-fom-<tier>.webp). A tier with no picture of its own (the sold out 2000)
       shows the next lower tier's picture greyed, never a broken image. */
    function fomPic(f, big) {
      var M2 = big ? (D.fomImgBig || D.fomImg || {}) : (D.fomImg || {});
      if (M2[f]) return { url: M2[f], own: true };
      var keys = Object.keys(M2).sort(function (a, b) { return num(a) - num(b); }), best = null;
      for (var i = 0; i < keys.length; i++) if (num(keys[i]) <= num(f)) best = keys[i];
      return best ? { url: M2[best], own: false } : { url: '', own: false };
    }
    var built = '';
    function pos(frac) { return 'calc(26px + (100% - 52px) * ' + frac + ')'; }
    function buildSlider(cardKey) {
      if (!slider || !range || !stopsEl) return;
      var F = fomsOf(cardKey);
      var key = cardKey + ':' + F.join(',');
      if (built === key) return;
      built = key;
      var old = slider.querySelectorAll('.no-buy__dot');
      for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
      var last = Math.max(1, F.length - 1);
      var sh = '';
      for (var k = 0; k < F.length; k++) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'no-buy__dot'; d.setAttribute('data-acb-dot', String(k));
        d.setAttribute('aria-label', F[k] + ' FOM'); d.style.left = pos(k / last);
        slider.insertBefore(d, range);
        sh += '<button type="button" data-acb-stop="' + k + '"><b>' + esc(F[k]) + '</b><small data-acb-snote="' + k + '"></small></button>';
      }
      range.min = '0'; range.max = String(F.length - 1); range.step = '1';
      setHtml(stopsEl, sh);
    }
    function paintSlider() {
      if (!fomBox) return;
      var on = S.card !== 'alone';
      fomBox.hidden = !on;
      if (!on) return;
      var ck = S.card, h = housingOf(ck), F = fomsOf(ck);
      buildSlider(ck);
      var idx = Math.max(0, F.indexOf(S.f[ck]));
      var last = Math.max(1, F.length - 1);
      var frac = idx / last;
      if (range) { range.value = String(idx); range.setAttribute('aria-valuetext', S.f[ck] + ' FOM'); }
      if (fill) fill.style.width = 'calc((100% - 52px) * ' + frac + ')';
      if (knob) knob.style.left = pos(frac);
      /* the price step under each live number is measured from the lowest priced live tier */
      var base = null, k;
      for (k = 0; k < F.length; k++) { var tb = tierOf(ck, h, F[k]); if (live(tb) && (base === null || tb.price < base)) base = tb.price; }
      var why = [];
      var dots = slider ? slider.querySelectorAll('[data-acb-dot]') : [];
      var stops = stopsEl ? stopsEl.querySelectorAll('[data-acb-stop]') : [];
      for (k = 0; k < F.length; k++) {
        var t = tierOf(ck, h, F[k]);
        var ok = live(t);
        var reason = ok ? '' : (t ? 'Sold out' : (ck === 'pvs14' && h === 'std' && tierOf(ck, 'pro', F[k]) ? 'PRO only' : 'Not made'));
        if (!ok) why.push(F[k] + (reason === 'PRO only' ? ' in PRO housing only' : ' ' + reason.toLowerCase()));
        if (dots[k]) {
          dots[k].classList.toggle('is-on', k <= idx && ok);
          dots[k].classList.toggle('is-dead', !ok);
          dots[k].disabled = !ok;
        }
        if (stops[k]) {
          stops[k].classList.toggle('is-on', k === idx);
          stops[k].disabled = !ok;
          stops[k].setAttribute('aria-pressed', k === idx ? 'true' : 'false');
          var sn = stops[k].querySelector('small');
          var step = ok && base !== null && t.price > base ? '+' + moneyWhole(t.price - base) : '';
          if (sn) { setText(sn, ok ? step : reason); sn.classList.toggle('is-step', ok && !!step); }
        }
      }
      var cur = tierOf(ck, h, S.f[ck]);
      setText(fomV, cur ? (cur.range || cur.fom) + ' FOM' : '');
      setText(noteEl, 'Higher FOM, sharper and cleaner image.' + (why.length ? ' ' + why.join(', ') + '.' : ''));
      if (sampleEl) {
        var pic = fomPic(S.f[ck], false);
        if (pic.url && sampleEl.getAttribute('src') !== pic.url) sampleEl.setAttribute('src', pic.url);
        sampleEl.classList.toggle('is-dead', !live(cur) || !pic.own);
        sampleEl.setAttribute('alt', 'Sample view at ' + S.f[ck] + ' FOM (illustration)');
      }
    }
    function pickFom(i, dir) {
      var ck = S.card; if (ck === 'alone') return;
      var F = fomsOf(ck), h = housingOf(ck);
      i = Math.max(0, Math.min(F.length - 1, i));
      if (!live(tierOf(ck, h, F[i]))) {
        var found = -1, s, order = [];
        for (s = 1; s < F.length; s++) { if (dir >= 0) order.push(i + s, i - s); else order.push(i - s, i + s); }
        for (s = 0; s < order.length; s++) { var c = order[s]; if (c >= 0 && c < F.length && live(tierOf(ck, h, F[c]))) { found = c; break; } }
        if (found < 0) { paint(); return; }
        i = found;
      }
      S.f[ck] = F[i];
      paint();
    }
    if (range) {
      range.addEventListener('input', function () {
        var ck = S.card; if (ck === 'alone') return;
        var was = Math.max(0, fomsOf(ck).indexOf(S.f[ck]));
        var w = parseInt(range.value, 10) || 0;
        pickFom(w, w - was);
      });
    }

    /* ------------------------------------------------------------ paint */
    function paint() {
      settle('pvs14'); settle('pvs31');
      var cards = root.querySelectorAll('[data-acb-card]');
      for (var i = 0; i < cards.length; i++) {
        var ck = cards[i].getAttribute('data-acb-card');
        cards[i].setAttribute('aria-checked', ck === S.card ? 'true' : 'false');
        var pills = cards[i].querySelectorAll('[data-acb-opt]');
        for (var p = 0; p < pills.length; p++) {
          var ov = pills[p].getAttribute('data-acb-opt');
          pills[p].setAttribute('aria-pressed', ck === 'pvs14' && ov === S.h14 ? 'true' : 'false');
          if (ck === 'pvs14') {
            var any = false;
            for (var q = 0; q < T.pvs14.length; q++) if (T.pvs14[q].h === ov && live(T.pvs14[q])) any = true;
            pills[p].disabled = !any;
          }
        }
        if (ck === 'pvs14') {
          var img = cards[i].querySelector('[data-acb-img14]');
          if (img) {
            var want = img.getAttribute(S.h14 === 'std' ? 'data-src-std' : 'data-src-pro');
            if (want && img.getAttribute('src') !== want) { img.setAttribute('src', want); img.removeAttribute('data-acb-fb'); }
            img.setAttribute('alt', S.h14 === 'std' ? 'Jerry-C Pro on a PVS-14 STANDARD' : 'Jerry-C Pro on a PVS-14 PRO');
          }
        }
        if (ck !== 'alone') {
          var badge = cards[i].querySelector('[data-acb-save]');
          if (badge && offFor(ck) > 0) setText(badge, APPROX ? 'Save US$' + usd0(ck) : 'Save ' + moneyWhole(offFor(ck)));
          if (cardLive(ck)) {
            var pr = priceOf(ck);
            setText(cards[i].querySelector('[data-acb-cprice]'), money(pr.price));
            var cw = cards[i].querySelector('[data-acb-cwas]');
            if (cw) setText(cw, pr.was ? money(pr.was) : '');
          }
        }
      }

      var P = priceOf(S.card);
      var o = companion(S.card);
      setText(vEl, o ? 'Jerry-C Pro + ' + o.short : D.cards.alone.name);
      setText(priceEl, money(P.price));
      setText(wasEl, P.was > P.price ? money(P.was) : '');
      if (addBtn) addBtn.disabled = !P.ok;
      setText(addLabel, P.ok ? 'Add to cart' : 'Sold out');
      setText(addPrice, P.ok ? money(P.price) : '');
      if (errEl) errEl.hidden = true;

      if (cartEl) {
        var L = linesOf(S.card);
        var h = '<p class="no-buy__carth">What goes in the cart, ' + L.length + (L.length === 1 ? ' line' : ' lines') + '</p><ul>';
        for (var k = 0; k < L.length; k++) {
          h += '<li><span class="no-buy__nm">' + esc(L[k].name) +
            '<span class="no-buy__sku">' + esc(L[k].sku) + ' &middot; qty 1</span>' +
            (L[k].elf && D.comesWith ? '<span class="no-buy__sku no-buy__comes">' + esc(D.comesWith) + '</span>' : '') +
            '</span><span class="no-buy__amt">' + esc(money(L[k].price)) + '</span></li>';
        }
        if (L.length > 1 && offFor(S.card) > 0) {
          h += '<li><span class="no-buy__nm">Kit saving' + (APPROX ? ' (US$' + usd0(S.card) + ')' : '') +
            '<span class="no-buy__sku no-buy__comes">Taken off automatically in the cart' +
            (APPROX ? ', shown in your currency at the store rate' : '') + '.</span></span>' +
            '<span class="no-buy__amt is-off">' + esc(money(-offFor(S.card))) + '</span></li>';
        }
        h += '</ul><p class="no-buy__cartf">' + (home
          ? (L.length > 1 ? 'Two cart lines, one order, two parcels.' : 'One parcel.')
          : (L.length > 1 ? 'Two cart lines, one order.' : 'One cart line.')) + '</p>';
        setHtml(cartEl, h);
      }
      paintSlider();
      askArrival();
    }

    /* ------------------------------------------------------------ live stock */
    /* The tiers Liquid printed can be a few minutes old (page cache). Read the
       two products once, by SKU, and repaint. A failed read keeps Liquid's list. */
    function readLive(handle, cardKey) {
      if (!handle || !window.fetch) return;
      fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.variants) return;
          var by = {};
          for (var i = 0; i < p.variants.length; i++) by[String(p.variants[i].sku || '').toUpperCase()] = p.variants[i];
          var L = T[cardKey];
          for (var j = 0; j < L.length; j++) {
            var v = by[String(L[j].sku || '').toUpperCase()];
            if (!v) { L[j].available = false; continue; }
            L[j].available = v.available === true;
            if (typeof v.price === 'number' && v.price > 0) L[j].price = v.price;
            L[j].compare = typeof v.compare_at_price === 'number' ? v.compare_at_price : 0;
            if (v.id) L[j].id = v.id;
          }
          paint();
        })
        .catch(function () { /* keep Liquid's list */ });
    }

    /* ------------------------------------------------------------ arrival */
    var deCache = {};
    var deToken = 0;
    function deFetch(sku, cb) {
      var key = sku + '|' + (D.country || '');
      if (Object.prototype.hasOwnProperty.call(deCache, key)) { cb(deCache[key]); return; }
      var url = D.deEndpoint + '?sku=' + encodeURIComponent(sku) + '&country=' + encodeURIComponent(D.country || '') + '&cur=' + encodeURIComponent(D.currency || '');
      var ctl = null;
      try { ctl = new AbortController(); setTimeout(function () { ctl.abort(); }, 4000); } catch (e) { ctl = null; }
      fetch(url, ctl ? { signal: ctl.signal, credentials: 'omit' } : { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (window.noInbound) { try { j = window.noInbound(j, D.country, D.currency); } catch (e2) { /* keep the raw answer */ } }
          deCache[key] = j; cb(j);
        })
        .catch(function () { cb(null); });
    }

    function daysFromLabel(lab) {
      var s = String(lab == null ? '' : lab);
      var words = s.match(/[A-Za-z]{3,}/g);
      var dm = s.match(/(\d{1,2})(?!\d)/);
      if (!words || !dm) return null;
      var mo = null;
      for (var i = 0; i < words.length; i++) {
        var k = words[i].slice(0, 3).toLowerCase();
        if (Object.prototype.hasOwnProperty.call(MONTHS, k)) { mo = MONTHS[k]; break; }
      }
      if (mo === null) return null;
      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var d = new Date(today.getFullYear(), mo, parseInt(dm[1], 10));
      if ((d - today) < -180 * 86400000) d = new Date(today.getFullYear() + 1, mo, parseInt(dm[1], 10));
      var diff = Math.round((d - today) / 86400000);
      return diff >= 0 ? diff : null;
    }

    /* HOW LONG AN ANSWER SAYS, IN DAYS, read off the server's own words: the
       outer date on a shelf answer, the top of the week window on any other.
       Unknown is null, never zero. A refusal (us_only) is the slowest of all. */
    function spanOf(a) {
      if (!a || a.show !== true) return null;
      var m = String(a.mode || '');
      if (m === 'us_only' || a.buyable === false) return { days: 99999, phrase: '' };
      if (m === 'eta') {
        var mn = daysFromLabel(a.min_label), mx = daysFromLabel(a.max_label);
        if (mx === null) return null;
        return { days: mx, phrase: mn !== null && mn !== mx ? mn + ' to ' + mx + ' days' : mx + ' days' };
      }
      var t = String(a.lead_text_short || a.lead_text || a.eta_text || '');
      var w = t.match(/(\d+)\s*(?:to\s*(\d+)\s*)?weeks?/i);
      if (!w) return null;
      var top = parseInt(w[2] || w[1], 10);
      return { days: top * 7, phrase: w[2] ? w[1] + ' to ' + w[2] + ' weeks' : w[1] + (w[1] === '1' ? ' week' : ' weeks') };
    }

    function row(cls, tagText, lead, sub) {
      return '<div class="no-buy__row"><span class="no-buy__rtag"><span class="no-buy__tag no-buy__tag--' + cls + '">' + esc(tagText) +
        '</span></span><span class="no-buy__rtxt">' + lead + (sub ? '<span class="no-buy__rsub">' + sub + '</span>' : '') + '</span></div>';
    }
    /* one row per part, every word after the name is the server's */
    function partRow(name, a) {
      var m = String(a.mode || '');
      if (m === 'eta') {
        var sp = spanOf(a);
        return row('green', 'US warehouse', 'The ' + esc(name) + ' arrives in about <b>' + esc(sp ? sp.phrase : '') + '</b>',
          'It leaves on its own as soon as it is packed.');
      }
      if (m === 'us_only' || a.buyable === false) {
        return row('red', a.chip_label || 'Not sold here', 'The ' + esc(name) + ': ' + esc(a.lead_text || ''), esc(a.note_text || ''));
      }
      var tagText = m === 'backorder' ? 'Backorder' : ((m === 'supplier' || a.tier === 'supplier') ? 'Supplier stock' : (m === 'intl' ? 'Made to order' : 'Built to order'));
      var sub = (!home && m === 'backorder' && a.note_text) ? esc(a.note_text) : '';
      return row(m === 'backorder' ? 'red' : 'grey', tagText, 'The ' + esc(name) + ': ' + esc(a.lead_text_short || a.lead_text || ''), sub);
    }

    /* the Jerry-C Pro's own answer, or Bon's 11 Oct window while the function has
       none for it yet ("Shipping times are roughly 4 weeks"). US only: outside
       the USA no window is invented here. */
    function elfAnswer(a) {
      if (a && a.show === true) return a;
      if (!home) return null;
      return { show: true, mode: 'supplier', lead_text: D.leadFallback, fallback: true };
    }

    function askArrival() {
      var mine = ++deToken;
      var o = companion(S.card);
      var got = { elf: undefined, nv: o ? undefined : null };
      function done() {
        if (mine !== deToken || got.elf === undefined || got.nv === undefined) return;
        paintArrival(o, elfAnswer(got.elf), got.nv, !!(got.elf && got.elf.show === true));
      }
      deFetch(D.elf.sku, function (j) { got.elf = j; done(); });
      if (o) deFetch(o.sku, function (j) { got.nv = j; done(); });
    }

    function paintArrival(o, ea, na, cardSpeaking) {
      if (!home) {
        /* OUTSIDE THE USA: the store card already says the Jerry-C Pro's window
           and the duty line. On a kit, one row per part, each the server's own
           words, and no "whole kit" sum: a factory build time plus a transit
           window are not one number. */
        if (estHead) estHead.hidden = true;
        if (!o) { setHtml(rowsEl, ''); return; }
        var r = [];
        if (na && na.show === true) r.push(partRow(o.short, na));
        if (ea && ea.show === true) r.push(partRow(D.shortName, ea));
        setHtml(rowsEl, r.join(''));
        return;
      }
      if (!o) {
        if (estHead) estHead.hidden = true;
        /* the store card already says it when the server answers; else Bon's window */
        setHtml(rowsEl, (!cardSpeaking && ea) ? row('grey', 'Supplier stock', esc(ea.lead_text), '') : '');
        return;
      }
      if (estHead) estHead.hidden = false;
      var rows = [];
      var se = spanOf(ea), sn = spanOf(na);
      var slow = null, slowName = '';
      if (se && (!sn || se.days >= sn.days)) { slow = se; slowName = D.shortName; }
      else if (sn) { slow = sn; slowName = o.short; }
      if (slow && slow.days < 99999 && slow.phrase) {
        rows.push('<p class="acb__kitline">Whole kit with you in about <b>' + esc(slow.phrase) + '</b>. The ' + esc(slowName) +
          ' is the slower part, so it sets the date.</p>');
      }
      if (na && na.show === true) rows.push(partRow(o.short, na));
      if (ea && ea.show === true) rows.push(partRow(D.shortName, ea));
      setHtml(rowsEl, rows.join(''));
    }

    /* ------------------------------------------------------------ input */
    function pick(cardKey) {
      if (!D.cards[cardKey] || !cardLive(cardKey)) return;
      S.card = cardKey;
      paint();
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var stop = t.closest ? t.closest('[data-acb-stop],[data-acb-dot]') : null;
      if (stop && root.contains(stop)) {
        if (stop.disabled) return;
        var ci = parseInt(stop.getAttribute('data-acb-stop') || stop.getAttribute('data-acb-dot'), 10);
        if (ci >= 0) pickFom(ci, 0);
        return;
      }
      var pill = t.closest ? t.closest('[data-acb-opt]') : null;
      var card = t.closest ? t.closest('[data-acb-card]') : null;
      if (!card || !root.contains(card)) return;
      var ck = card.getAttribute('data-acb-card');
      if (pill && ck === 'pvs14') {
        if (pill.disabled) return;
        S.h14 = pill.getAttribute('data-acb-opt') === 'std' ? 'std' : 'pro';
      }
      pick(ck);
    });
    root.addEventListener('keydown', function (e) {
      var card = e.target && e.target.getAttribute ? e.target : null;
      if (!card || !card.hasAttribute('data-acb-card')) return;
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); pick(card.getAttribute('data-acb-card')); }
    });

    /* a card picture that is not uploaded yet falls back to the product picture */
    root.addEventListener('error', function (e) {
      var img = e.target;
      if (img && img.tagName === 'IMG' && img.hasAttribute('data-acb-imgfb') && !img.getAttribute('data-acb-fb')) {
        img.setAttribute('data-acb-fb', '1');
        var fb = root.getAttribute('data-acb-fallback') || '';
        if (fb) img.src = fb;
      }
    }, true);

    /* ------------------------------------------------------------ cart */
    var busy = false;
    function cartHost() { return document.querySelector('cart-notification') || document.querySelector('cart-drawer'); }
    function sectionIds(host) {
      try {
        if (host && typeof host.getSectionsToRender === 'function') {
          return host.getSectionsToRender().map(function (s) { return s.section || s.id; }).filter(Boolean);
        }
      } catch (e) { /* the drawer simply will not be repainted */ }
      return [];
    }
    function release() { busy = false; if (addBtn) { addBtn.removeAttribute('aria-busy'); addBtn.disabled = !priceOf(S.card).ok; } }
    function showErr(msg) { if (!errEl) return; errEl.textContent = msg; errEl.hidden = false; }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        if (addBtn && addBtn.disabled) return;
        var L = linesOf(S.card);
        for (var i = 0; i < L.length; i++) { if (!L[i].id) { showErr('This kit cannot be added right now.'); return; } }
        busy = true;
        if (addBtn) { addBtn.setAttribute('aria-busy', 'true'); addBtn.disabled = true; }
        var payload = { items: [] };
        for (var j = 0; j < L.length; j++) payload.items.push({ id: L[j].id, quantity: 1 });
        var host = cartHost();
        var ids = sectionIds(host);
        if (ids.length) { payload.sections = ids.join(','); payload.sections_url = window.location.pathname; }
        fetch(D.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json().then(function (jj) { return { ok: r.ok, body: jj }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body && res.body.description ? res.body.description : 'Add to cart failed');
            var opened = false;
            try {
              if (host && typeof host.renderContents === 'function' && res.body && res.body.sections) {
                if (host.classList && host.classList.contains('is-empty')) host.classList.remove('is-empty');
                host.renderContents(res.body);
                opened = true;
              }
            } catch (err2) { opened = false; }
            try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (err4) { /* older browser */ }
            release();
            if (!opened) window.location.href = D.cartUrl;
          })
          .catch(function (err) { release(); showErr(err && err.message ? err.message : 'Add to cart failed'); });
      });
    }

    /* ------------------------------------------------------------ the pop up */
    var zoom = null;
    function zoomEl() {
      if (zoom) return zoom;
      zoom = document.createElement('div');
      zoom.className = 'no-buy__zoom'; zoom.hidden = true;
      zoom.setAttribute('role', 'dialog'); zoom.setAttribute('aria-modal', 'true'); zoom.setAttribute('aria-label', 'Tube grade sample');
      zoom.innerHTML = '<div class="no-buy__zbox"><div class="no-buy__ztop"><span class="no-buy__zt" data-z-title></span>' +
        '<button type="button" class="no-buy__zx" data-z-close aria-label="Close">&times;</button></div>' +
        '<img class="no-buy__zimg" data-z-img src="" alt="Sample view at the chosen tube grade" decoding="async">' +
        '<div class="no-buy__zthumbs" data-z-thumbs></div>' +
        '<p class="no-buy__zcap">Illustration, not a photo through that exact tube.</p></div>';
      root.appendChild(zoom);
      zoom.addEventListener('click', function (e) {
        if (e.target === zoom || (e.target.closest && e.target.closest('[data-z-close]'))) { closeZoom(); return; }
        var b = e.target.closest ? e.target.closest('[data-z-n]') : null;
        if (b && !b.disabled && zoom.__pick) { zoom.__pick(b.getAttribute('data-z-n')); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && zoom && !zoom.hidden) closeZoom(); });
      return zoom;
    }
    function closeZoom() { if (!zoom) return; zoom.classList.remove('is-open'); zoom.hidden = true; }
    /* opts: { tiers: [{n, dead}], current: n, pick: function (n) -> new current } */
    function openZoom(opts) {
      var z = zoomEl();
      function draw(cur) {
        setText(z.querySelector('[data-z-title]'), cur + ' FOM');
        var big = fomPic(cur, true), im = z.querySelector('[data-z-img]');
        if (big.url && im.getAttribute('src') !== big.url) im.setAttribute('src', big.url);
        var curDead = false, h = '';
        for (var i = 0; i < opts.tiers.length; i++) {
          var t = opts.tiers[i], p = fomPic(t.n, false);
          if (t.n === cur && t.dead) curDead = true;
          h += '<button type="button" data-z-n="' + esc(t.n) + '" class="' + (t.n === cur ? 'is-on' : '') + '"' + (t.dead ? ' disabled' : '') + '>' +
            '<img src="' + esc(p.url) + '" alt="" decoding="async"' + (p.own ? '' : ' style="filter:grayscale(1);opacity:.35"') + '><span>' + esc(t.n) + '</span></button>';
        }
        im.style.filter = (curDead || !big.own) ? 'grayscale(1)' : '';
        im.style.opacity = (curDead || !big.own) ? '.45' : '';
        setHtml(z.querySelector('[data-z-thumbs]'), h);
      }
      z.__pick = function (n) { var now = opts.pick ? opts.pick(n) : n; draw(now || n); };
      draw(opts.current);
      z.hidden = false; z.classList.add('is-open');
      var x = z.querySelector('[data-z-close]'); if (x) x.focus();
    }
    if (sampleBtn) {
      sampleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var ck = S.card; if (ck === 'alone') return;
        var F = fomsOf(ck), h = housingOf(ck), L = [];
        for (var i = 0; i < F.length; i++) L.push({ n: F[i], dead: !live(tierOf(ck, h, F[i])) });
        openZoom({ tiers: L, current: S.f[ck], pick: function (n) {
          var at = fomsOf(S.card).indexOf(n); if (at >= 0) pickFom(at, 0); return S.f[S.card];
        } });
      });
    }
    /* the dark kit card sliders on this page use the same pop up and pictures (assets/advcoti-fompic-1014.js) */
    window.acbFomZoom = { open: openZoom, pic: fomPic };
    try { document.dispatchEvent(new CustomEvent('acb:fomzoom')); } catch (e5) { /* older browser */ }

    /* for the proof rig: the lines the button would send right now */
    root.__acbLines = function () { return linesOf(S.card).map(function (l) { return { id: l.id, sku: l.sku, quantity: 1 }; }); };
    root.__acbState = function () { return { card: S.card, h14: S.h14, f: { pvs14: S.f.pvs14, pvs31: S.f.pvs31 }, price: priceOf(S.card) }; };

    paint();
    readLive(D.h14, 'pvs14');
    readLive(D.h31, 'pvs31');
  }

  function all() {
    var roots = document.querySelectorAll('[data-acb]');
    for (var i = 0; i < roots.length; i++) boot(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
